export default {
    dh_dashboard_metrics: '/dashboard/digital-human/metrics',
    dh_dashboard_preferences: 'preference',
    report_sidebar: '/report',
    cube_api: '/cube',
};
